"use client"

import { motion } from "framer-motion"

interface SectionDividerProps {
    variant?: "wave" | "gradient" | "dots"
    className?: string
    flip?: boolean
}

export function SectionDivider({ variant = "wave", className = "", flip = false }: SectionDividerProps) {
    if (variant === "wave") {
        return (
            <div className={`relative w-full overflow-hidden ${flip ? "rotate-180" : ""} ${className}`}>
                <motion.svg
                    viewBox="0 0 1200 120"
                    preserveAspectRatio="none"
                    className="relative block w-full h-16 md:h-24"
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                >
                    <motion.path
                        d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V120H0V95.8C57.1,118.92,156.63,69.08,321.39,56.44Z"
                        fill="url(#wave-gradient)"
                        initial={{ pathLength: 0 }}
                        whileInView={{ pathLength: 1 }}
                        viewport={{ once: true }}
                        transition={{ duration: 1.5, ease: "easeOut" }}
                    />
                    <defs>
                        <linearGradient id="wave-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                            <stop offset="0%" stopColor="hsl(var(--primary) / 0.1)" />
                            <stop offset="50%" stopColor="hsl(var(--primary) / 0.2)" />
                            <stop offset="100%" stopColor="hsl(var(--primary) / 0.1)" />
                        </linearGradient>
                    </defs>
                </motion.svg>
            </div>
        )
    }

    if (variant === "gradient") {
        return (
            <motion.div
                initial={{ scaleX: 0 }}
                whileInView={{ scaleX: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                className={`h-px bg-gradient-to-r from-transparent via-primary/50 to-transparent ${className}`}
            />
        )
    }

    if (variant === "dots") {
        return (
            <div className={`flex justify-center gap-2 py-8 ${className}`}>
                {[0, 1, 2].map((i) => (
                    <motion.div
                        key={i}
                        initial={{ scale: 0, opacity: 0 }}
                        whileInView={{ scale: 1, opacity: 1 }}
                        viewport={{ once: true }}
                        transition={{ delay: i * 0.1, duration: 0.3 }}
                        className="w-2 h-2 rounded-full bg-primary/50"
                    />
                ))}
            </div>
        )
    }

    return null
}
